import {React} from "react"
import { Link } from "react-router-dom"
import { Button } from "./ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu"
import { useFetchSubscriptions } from "../hooks/DataFetching/useFetchSubscriptions"
import { Users, Loader, Search, PlusCircle } from "lucide-react"

const MyColoniesDropdown = () => {
  const { subscriptions, loading } = useFetchSubscriptions()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="text-primary-foreground">
          <Users className="mr-2 h-4 w-4" />
          My Communities
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {loading ? (
          <DropdownMenuItem disabled>
            <Loader className="mr-2 h-4 w-4 animate-spin" />
            Loading...
          </DropdownMenuItem>
        ) : subscriptions && subscriptions.length > 0 ? (
          subscriptions.map((subscription) => (
            <DropdownMenuItem key={subscription.id} asChild>
              <Link to={`/group-members/${subscription.groupId}`}>{subscription.groupName}</Link>
            </DropdownMenuItem>
          ))
        ) : (
          <DropdownMenuItem disabled>No communities found</DropdownMenuItem>
        )}
        <DropdownMenuItem asChild>
          <Link to="/fetch-groups">
            <Search className="mr-2 h-4 w-4" />
            Find a Community
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/post-group">
            <PlusCircle className="mr-2 h-4 w-4" />
            Start a Community
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default MyColoniesDropdown

